export const removeNaN = (word: string) => {
  return word?.replace(/[^\d.]/g, "");
};
